/*
 * Authors: mariushirjanu
 * Created: 12/01/2023
 */
import { trackByFunction } from '../../../../shared/formly/ga-formly.util';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ICatalogLayout, OrderCatalogService } from '../order-catalog.service';
import { CatalogOverviewService } from './catalog-overview.service';
import { GaEventService, IGAEvent } from '../../../../shared/services/ga-event.service';
import { Subscription } from 'rxjs';
import { EVENT_ORDER_CATALOG_PRODUCTS_CHANGED, EVENT_ORDER_CATEGORIES_LOADED } from '../../../../shared/app-events';
import { util } from '../../../../shared/util';
import { StateService } from '@uirouter/angular';
import { ICatalogSearchParam } from './order-catalog-overview.component';
import { ICatalogProduct } from '../order-catalog-data.service';

@Component({
  selector: 'catalog-content',
  template: `
    <div *ngIf="categoriesLoaded && !isOnlyButtonTypeCategories && nothingFound">
      <h2 translate>CATALOG.NO_PRODUCTS</h2>
    </div>
    <div *ngIf="categoriesLoaded && !isOnlyButtonTypeCategories && emptyCatalog">
      <h2 translate>CATALOG.EMPTY_CATALOG</h2>
    </div>
    <div *ngIf="searching" class="catalog-search-overlay">
      <div class="bg"></div>
      <div class="text">
        <i class="fa fa-spinner fa-spin"></i>
        <div>&nbsp;<span translate>CATALOG.SEARCHING</span>…</div>
      </div>
    </div>
    
    <div *ngIf="numPages"> 

      <!-- Layout: block -->
      <div *ngIf="selectedLayout.name === 'block'">
        <catalog-overview-layout-block [products]="products" [compatibleProductId]="compatibleProductId" [showStock]="showStock" [showLease]="showLease" [hidePrices]="hidePrices"></catalog-overview-layout-block>
      </div>

      <!-- Layout: tab-light -->
      <div *ngIf="selectedLayout.name === 'tab-light'">
        <catalog-overview-layout-tablight [products]="products" [showStock]="showStock" [showLease]="showLease" [hidePrices]="hidePrices"></catalog-overview-layout-tablight>
      </div>

      <!-- Layout: tab-basic -->
      <div *ngIf="selectedLayout.name === 'tab-basic'">
        <catalog-overview-layout-tabularbasic [products]="products" [compatibleProductId]="compatibleProductId" [showStock]="showStock" [hasCartAction]="true" [showLease]="showLease" [hidePrices]="hidePrices"></catalog-overview-layout-tabularbasic>
      </div>

    </div>
  `
})
export class CatalogContentComponent implements OnInit, OnDestroy {
  @Input() public selectedLayout:ICatalogLayout;
  @Input() public searching:boolean;
  @Input() public searchParams:ICatalogSearchParam;

  public trackByFunction:Function = trackByFunction;
  public products:ICatalogProduct[];
  public numPages:number;
  public defaultSearch:boolean;
  public nothingFound:boolean;
  public emptyCatalog:boolean;
  public compatibleProductId:number;
  public showStock:boolean;
  public isOnlyButtonTypeCategories:boolean;
  public categoriesLoaded:boolean;
  public showLease:boolean;
  public hidePrices:boolean;

  private eventHandler:Subscription;

  constructor(
    private orderCatalogService:OrderCatalogService,
    private catalogOverviewService:CatalogOverviewService,
    private eventService:GaEventService,
    private stateService:StateService
  ) {
    /***/
  }

  public ngOnInit():void {
    this.activate();
    this.listen();
  }

  private activate():void {
    this.defaultSearch = util.isNullOrUndefined(this.stateService.params.fav) && util.isNullOrUndefined(this.stateService.params.instock) && util.isNullOrUndefined(this.stateService.params.cat) && util.isNullOrUndefined(this.stateService.params.terms) && util.isNullOrUndefined(this.stateService.params.pmin) && util.isNullOrUndefined(this.stateService.params.pmax) && util.isNullOrUndefined(this.stateService.params.filters);
    this.compatibleProductId = Number(this.stateService.params.compat);
    this.showStock = this.orderCatalogService.showStock;
    this.hidePrices = this.orderCatalogService.hidePrices;
    this.showLease = this.orderCatalogService.isLeasingWebshop;
    this.onProductsLoaded();
  }

  private listen():void {
    this.eventHandler = this.eventService.events.subscribe((event:IGAEvent) => {
      if (event.name === EVENT_ORDER_CATALOG_PRODUCTS_CHANGED) {
        this.onProductsLoaded();
      }
      if (event.name === EVENT_ORDER_CATEGORIES_LOADED) {
        this.isOnlyButtonTypeCategories = this.orderCatalogService.accessTypeButtonCategory?.length > 0 && !this.orderCatalogService.filteredCategories?.length;
        this.categoriesLoaded = true;
      }
    });
  }

  private onProductsLoaded():void {
    this.products = this.catalogOverviewService.products;
    this.numPages = this.catalogOverviewService.numPages || 0;

    this.nothingFound = !this.numPages && !this.defaultSearch;
    this.emptyCatalog = !this.numPages && this.defaultSearch;
  }

  public ngOnDestroy():void {
    this.eventHandler?.unsubscribe();
  }
}